import { useEffect } from 'react'

import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import {
  handleConversionCompleted,
  handleConversionFailed,
} from 'Pods/ThreeDStudio/Store/actions/export'
import { EXPORT_IN_FLIGHT_STATUSES } from 'Pods/ThreeDStudio/Store/slices/export'

const EVENT_TYPE = 'generator/asset_conversions/update'

export default function useExportConversionChannel() {
  const runId = useThreeDStudioStore(state => (
    EXPORT_IN_FLIGHT_STATUSES.has(state.export.status) ? state.export.activeConversion?.runId : null
  ))
  const conversionId = useThreeDStudioStore(state => (
    EXPORT_IN_FLIGHT_STATUSES.has(state.export.status) ? state.export.activeConversion?.conversionId : null
  ))

  useEffect(() => {
    if (runId == null || conversionId == null || !window.App?.cable?.subscriptions) {
      return undefined
    }

    const subscription = window.App.cable.subscriptions.create(
      { channel: 'GeneratorRunsChannel', run_id: runId },
      {
        received(message) {
          if (message?.type !== EVENT_TYPE) return

          const data = message?.data || {}
          if (String(data.conversion_id) !== String(conversionId)) return

          if (data.status === 'completed') {
            handleConversionCompleted(data)
          } else if (data.status === 'failed') {
            handleConversionFailed()
          }
        },
      },
    )

    return () => subscription.unsubscribe()
  }, [runId, conversionId])
}
